import React from 'react';
import './TechStack.css'; 
import Icon from '../Icon/Icon'; 

// TechStack component
const TechStack: React.FC = () => {
  // List of tech stack icons
  const techStackIcons: string[] = [
    'Git',
    'Github',
    'Nextjs',
    'Node',
    'Typescript',
    'Express',
    'Java',
    'SQL',
    'Json',
    'React',
    'Restapi',
  ];

  return (
    <div id="tech" className="tech-stack main-section">
      <h2 className="title">Tech Stack</h2>
      <div className="icon-container">
        {techStackIcons.map((iconName, index) => (
          <Icon key={index} name={iconName} />
        ))}
      </div>
    </div>
  );
};

export default TechStack;
